import { tApi } from 'tplus-api';
import '../commom/Challenger';
import CutRetailDto from './CutRetailDto';
/**
 * 零售单本身相关的API
 */
export default class RetailApi {
    /**
     *获取单据编码
     *
     * @static
     * @param {*} dto
     * @returns
     * @memberof RetailApi
     */
    static async GetCode(dto) {
        let code = '';
        let dtoTemp= {};
        dtoTemp.POSCode=dto.POSCode;
        dtoTemp.VoucherDate=dto.VoucherDate;
        dtoTemp.IdmarketingOrgan=dto.IdmarketingOrgan;
        
        try{
            code = await tApi({
                'dto':dtoTemp
            }, 'chanjet.RE.Interface.INewRetail.GetCode', false, false);
        }catch(err){
            console.log(err.message);
        }
        return code;
    }

/**
     *获取单据编码
     *
     * @static
     * @param {*} dto
     * @returns
     * @memberof RetailApi
     */
    static async GetInstance(dto) {
        let retailDTO = null;
        let dtoTemp = {};
        dtoTemp.POSCode = dto.POSCode;
        dtoTemp.VoucherDate = dto.VoucherDate;
        dtoTemp.IdmarketingOrgan = dto.IdmarketingOrgan;
        try {
            retailDTO = await tApi({ 'dto': dtoTemp }, 'chanjet.RE.Interface.INewRetail.GetInstance', false, false);
        } catch (err) {
            console.log(err.message);
        }
        return retailDTO;
    }
    
    /**
     *获取零售单的可用量
     *
     * @param {*} dto
     * @memberof RetailApi
     */
    static async getRetailAvailableQuantity(dto)
    {
        // let dtoTemp= JSON.Clone(dto);
        let dtoTemp=CutRetailDto(dto);
        $T.debugger();
        let result = await tApi({
            'dto':dtoTemp
        }, 'chanjet.RE.Interface.INewRetail.GetRetailAvailableQuantity', false, false);
        $T.debugger();
        return result;
    }
    /**
     * 获取失效日期
     * @param {*} retailDetailDTO 
     */
    static async getExpiryDate(retailDetailDTO)
    {
        let dtoTemp={};
        dtoTemp.Idinventory= retailDetailDTO.Idinventory;
        dtoTemp.ProductionDate= retailDetailDTO.ProductionDate;
        dtoTemp.ExpiryDate= retailDetailDTO.ExpiryDate;
        $T.debugger();
        let result = await tApi({
            'retailDetailDTO':dtoTemp
        }, 'chanjet.RE.Interface.INewRetail.GetExpiryDate', false, false);
        $T.debugger();
        return result;
    }

    /**
     * 获取失效日期
     * @param {*} retailDetailDTO 
     */
    static async getProductionDate(retailDetailDTO)
    {
        let dtoTemp={};
        dtoTemp.Idinventory= retailDetailDTO.Idinventory;
        dtoTemp.ProductionDate= retailDetailDTO.ProductionDate;
        dtoTemp.ExpiryDate= retailDetailDTO.ExpiryDate;

        $T.debugger();
        let result = await tApi({
            'retailDetailDTO':dtoTemp
        }, 'chanjet.RE.Interface.INewRetail.GetProductionDate', false, false);
        $T.debugger();
        return result;
    }
}

